import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import {ApiServices} from '../../shared/services/api.service';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {DataService} from '../../shared/services/data.service';
import {MetaService} from '../../shared/services/meta.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HelperService} from '../../shared/services/helper.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-vendor-login',
  templateUrl: './vendor-login.component.html',
  styleUrls: ['./vendor-login.component.scss']
})
export class VendorLoginComponent implements OnInit {

  form: FormGroup;
  registerProcessing = false;
  registerSubscription: Subscription;
  signupform = true;
  loginform = false;


  usStates: any;
  countries:any;
  showUSstate:boolean = true;

  constructor(
    private apiService: ApiServices,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private dataService: DataService, private metaService: MetaService, private activatedRoute: ActivatedRoute,private helperService: HelperService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],

      phone: ['', [Validators.required, Validators.maxLength(50)]],
      country: ['', [Validators.required, Validators.maxLength(50)]],
      state: ['', [Validators.required, Validators.maxLength(50)]],
      city: ['', [Validators.required, Validators.maxLength(50)]],
      zip: ['', [Validators.required, Validators.maxLength(10)]],
      address: ['', [Validators.required, Validators.maxLength(50)]],
      business_name: ['', [Validators.required, Validators.maxLength(50)]],
      business_address: ['', [Validators.required, Validators.maxLength(50)]]
    });
    
    helperService.setPageTitle(activatedRoute.snapshot.data.title);
  }

  ngOnInit(): void {
    this.metaService.updateCanonicalURL();

    let metaData: any = {
      title: this.activatedRoute.snapshot.data.breadcrumbs.title,
      description: this.activatedRoute.snapshot.data.breadcrumbs.description,
    };

    this.helperService.setCustomMeta(metaData);


    this.apiService.usStates().subscribe(response => {
      this.usStates = response.data.states;
      // console.log(response.data.states);
    });

    this.apiService.getCountries().subscribe(response => {
      this.countries = response.data.countries;

      this.form.value.country = 'United States';
    });


    // this.renderer.addClass(this.document.body, 'loginpage');
  }


    onCountrySelect(event): void {
		if(event.target.value == 'United States'){
			this.showUSstate = true;
		}else{
			this.showUSstate = false;
		}
	}


  onRegister(): void {
    if (this.form.valid) {
      this.registerProcessing = true;
      const name = this.form.value.name.split(' ');
      const formData = {
        first_name: name[0],
        last_name: name[1] ? name[1] : '',
        name: this.form.value.name,
        email: this.form.value.email,
        password: this.form.value.password,
        password_confirmation: this.form.value.password,
        phone: this.form.value.phone,
        country: this.form.value.country,
        state: this.form.value.state,
        city: this.form.value.city,
        address: this.form.value.address,
        business_name: this.form.value.business_name,
        business_address: this.form.value.business_address
      };

      this.registerSubscription = this.apiService.vendorRegister(formData).subscribe(
        response => {
          this.registerProcessing = false;
          if (response.status) {
            // this.dataService.isLoggedIn.next(true);
            // localStorage.setItem('ts_vendor_access_token', response.data.access_token);
            this.toastr.success(response.message, 'Success');
            // this.router.navigateByUrl('/my-account/my-profile');
          } else {
            this.registerProcessing = false;
            this.toastr.error(response.message, 'Error');
          }
        }, error => {
          this.registerProcessing = false;
          this.toastr.error(error.error.errors, 'Error');
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  showSignIn():void{
    this.loginform = true;
    this.signupform = false;
  }

  showSignUp():void{
    this.signupform = true;
    this.loginform = false;
  }


  ngOnDestroy() {
    if(this.registerSubscription) {
      this.registerSubscription.unsubscribe();
    }
     this.renderer.removeClass(this.document.body, 'loginpage');
  }


}
